import { useLocation, useNavigate } from "react-router";
import { SkyNavDrawer } from "@skypointcloud/skypoint-ui";
import { useMsalAuth } from "../../../hooks/useMsalAuth";
import { buildWorkforceNavSections, type WorkforceNavId } from "./workforceNavConfig";
import {
  getWorkforceNavRoute,
  getSelectedWorkforceNavItem,
  isModuleNeutralWorkforceRoute,
} from "../../dashboard/sidebar/routeMapping";

interface WorkforceSidebarProps {
  collapsed?: boolean;
  onCollapseChange?: (collapsed: boolean) => void;
}

/** Left-nav for the WLM module — same SkyNavDrawer chrome as the Service Desk sidebar. */
export function WorkforceSidebar({ collapsed, onCollapseChange }: WorkforceSidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { getQueryString } = useMsalAuth();

  const sections = buildWorkforceNavSections();
  const selectedId = getSelectedWorkforceNavItem(location.pathname);

  const handleNavSelect = (itemId: string) => {
    const navId = itemId as WorkforceNavId;
    const qs = getQueryString();
    /**
     * skyAgent and skyBrain live outside /workforce, so the shell would read
     * the path and flip the whole product back to Service Desk. `from=workforce`
     * is what isWorkforceContext consults to keep this module — the same
     * mechanism "View profile" uses for /account (#1046).
     */
    const from = isModuleNeutralWorkforceRoute(navId) ? `${qs ? "&" : "?"}from=workforce` : "";
    navigate(getWorkforceNavRoute(navId) + qs + from);
  };

  return (
    <SkyNavDrawer
      className="sky-nav"
      sections={sections}
      selectedId={selectedId}
      onSelect={handleNavSelect}
      size="small"
      collapsible
      onCollapseChange={onCollapseChange}
      {...(collapsed !== undefined ? { collapsed } : {})}
    />
  );
}
